export default [
  {
    title: 'Tableau de Bord',
    route: 'dashboard',
    icon: 'HomeIcon',
    authenticated: true,
  },
]